import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import { Card, CardContent, Grid, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Section, type SectionVariant } from "./Section";

interface Testimonial {
  quote: string;
  author: string;
  event: string;
}

interface TestimonialsSectionProps {
  variant?: SectionVariant;
}

export function TestimonialsSection({ variant }: TestimonialsSectionProps = {}) {
  const { t } = useTranslation(["landing", "common"]);
  const items = t("landing:testimonials.items", { returnObjects: true }) as Testimonial[];

  return (
    <Section
      id="testimonials"
      variant={variant}
      eyebrow={t("common:eyebrow.testimonials")}
      title={t("landing:testimonials.title")}
    >
      <Grid container spacing={3}>
        {Array.isArray(items) &&
          items.map((item) => (
            <Grid key={item.author} size={{ xs: 12, md: 4 }}>
              <Card sx={{ height: "100%", borderRadius: 4 }}>
                <CardContent sx={{ p: 4 }}>
                  <Stack spacing={2.5}>
                    <FormatQuoteIcon color="primary" sx={{ fontSize: 36 }} />
                    <Typography variant="body1" sx={{ fontStyle: "italic" }}>
                      “{item.quote}”
                    </Typography>
                    <Stack spacing={0.2}>
                      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                        {item.author}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {item.event}
                      </Typography>
                    </Stack>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          ))}
      </Grid>
    </Section>
  );
}
